
import _ from "lodash";
import React, {useMemo, useRef} from "react";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {Modal, Progress, Spin, Form, Input, Button, Alert, message} from "antd";

import LoginImageColoredSvg from "../../asset/icon/LoginImageColored.svg";
import LoginImageColoredPng from "../../asset/icon/LoginImageColored.png";
import Hotline from "./Hotline";
import css from "./BindAccount.scss";
import MainActions from "../../action/main/MainActions";
import LogoSvg from "../../asset/icon/AppName1.svg";

import AppLogoSvg from "../../asset/icon/AppLogo.svg";
import AppContext from "../../application/AppContext";

function BindAccountView({
    dataContext,
    actions,
}) {
    const formRef = useRef();
    const buttonDisabled = _.isEmpty(dataContext.joinData.mobile) || _.isEmpty(dataContext.joinData.SMSCode);
    return (
        <div
            className={css.container}
            style={{
                position: "absolute",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                display: "flex",
            }}
        >
            <div className={css.left}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    background: "#F5F9FC",
                    overflow: "hidden",
                }}
            >
                {/* {
                    mainDataContext.logoBase64
                        ? (
                            <img
                                height={36}
                                className={css.logo}
                                src={mainDataContext.logoBase64}
                            />
                        )
                        : (
                            
                        )
                } */}
                <div className={css.logo} style={{display: "flex", alignItems: "center"}}>
                    {
                        AppContext.hospitalConfig?.logoBase64 != null
                            ? <img src={AppContext.hospitalConfig?.logoBase64} height={55} width={55} />
                            : (
                                <AppLogoSvg
                                    style={{
                                        color: "#144CD0",
                                        flex: "none",
                                        fontSize: 55,
                                    }}
                                />
)
                    }
                    <span className="logoName" style={{fontSize: 40, color: "#144CD0", marginLeft: 20}}>{AppContext.hospitalConfig?.appName ?? "微晖医院管理"}</span>
                </div>

                <img src={LoginImageColoredPng} className={css.logoImage} style={{width: "340px", height: "223px"}} />
                {/* <LoginImageColoredSvg
                    className={css.logoImage}
                    style={{
                        flex: "none",
                    }}
                /> */}
            </div>
            <div className={css.right}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <div className={css.loginTitle}
                    style={{
                        fontWeight: "bold",
                        fontSize: 20,
                        color: "#111F2C",
                        flex: "none",
                    }}
                >绑定手机号
                </div>
                <div className={css.form}
                    style={{
                        flex: "none",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <div
                        style={{marginBottom: 32, flex: "none"}}
                    >
                        <Input
                            value={dataContext.joinData.mobile}
                            onChange={(e) => {
                                if (e.target.value.length > 11) {
                                    return;
                                }
                                actions.update({
                                    joinData: {
                                        mobile: e.target.value.trim(),
                                    },
                                });
                            }}
                            className={css.loginInput}
                            style={{padding: "13px 16px"}}
                            placeholder="请输入手机号"
                            size="large"
                            allowClear
                        />
                    </div>
                    <div
                        style={{marginBottom: 32, flex: "none", display: "flex", alignItems: "center"}}
                    >
                        <Input
                            className={css.loginInput}
                            style={{padding: "13px 16px"}}
                            placeholder="请输入验证码"
                            value={dataContext.joinData.SMSCode}
                            onChange={(e) => {
                                if (e.target.value?.length > 6) {
                                    return;
                                }
                                actions.update({
                                    joinData: {
                                        SMSCode: e.target.value?.trim?.(),
                                    },
                                });
                            }}
                            size="large"
                            allowClear
                        />
                        <Button
                            disabled={dataContext.SMSCodeStatus.disable}
                            onClick={() => {
                                const {mobile} = dataContext.joinData;
                                if (!mobile || mobile.length !== 11) {
                                    Modal.alert(
                                        null,
                                        "请输入正确的手机号码",
                                    );
                                } else {
                                    actions.getJoinSMSCode();
                                }
                            }}
                            style={{marginLeft: 12, flexShrink: 0, height: "100%"}}
                        >
                            {dataContext.SMSCodeStatus.disable
                                ? `已发送(${dataContext.SMSCodeStatus.seconds})`
                                : "获取验证码"
                            }
                        </Button>
                    </div>
                    {!_.isEmpty(dataContext.error?.message)
                        ? (
                            <Alert
                                style={{flex: "none", marginBottom: 8, borderRadius: "100vmax"}}
                                message={dataContext.error.message}
                                type="warning"
                                showIcon
                            />
                        )
                        : null}
                    <Button
                        style={{
                            flex: "none",
                            marginBottom: 32,
                            borderRadius: "100vmax",
                            padding: "11px 20px",
                            height: "unset",
                            fontSize: 20,
                            fontWeight: 500,
                            background: buttonDisabled ? "#A1B7EC" : "#144CD0",
                            color: "#fff",
                            border: "none",
                        }}
                        disabled={buttonDisabled}
                        type="primary"
                        htmlType="submit"
                        loading={dataContext.isBinding}
                        onClick={async () => {
                            const {mobile, SMSCode} = dataContext.joinData;
                            if (mobile == null || SMSCode == null) {
                                message.warn("请将手机号和验证码填写完整");
                                return;
                            }
                            actions.bindAccount();
                        }}
                    >
                        绑 定
                    </Button>
                </div>


                <Hotline style={{flex: "none"}} />

            </div>
        </div>
    );
}

export default connect(
    state => ({
        dataContext: state.mainViewModel,
    }),
    dispatch => ({
        actions: bindActionCreators(MainActions, dispatch),
    }),
)(BindAccountView);
